import { Amplify } from 'aws-amplify';

// Initial Amplify configuration - will be updated by configManager
// This is just a fallback configuration
Amplify.configure({
  Auth: {
    Cognito:{
      userPoolId: process.env['EXPO_PUBLIC_COGNITO_USER_POOL_ID']!,
      userPoolClientId: process.env['EXPO_PUBLIC_COGNITO_CLIENT_ID']!,
    }
  }
});

// Export function for dynamic reconfiguration
export function reconfigureAmplifyForUser(userPoolId: string, userPoolClientId: string) {
  Amplify.configure({
    Auth: {
      Cognito:{
        userPoolId,
        userPoolClientId,
      }
    }
  });
}